import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import {
  Accordion,
  paletteHelper,
  spacingHelper,
  Text,
  typographyHelper,
  mediaHelper,
} from '@property.com.au/ui-kit';
import {
  rowDisplacementValue,
  schoolNameWidth,
} from './subcomponents/SchoolAccordionItem/SchoolAccordionItem.styled';
import { SchoolAccordionItem } from './subcomponents/SchoolAccordionItem/SchoolAccordionItem';
import type { School } from './types';

interface SchoolsAccordionTableProps {
  schools?: School[] | null;
  schoolFactHeader: string[];
}

const DesktopSchoolFactHeaderWrapper = styled.div`
  ${mediaHelper('tabletMax')} {
    display: none;
  }
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  /* stylelint-disable declaration-block-no-redundant-longhand-properties */
  /* border + name size + margin + margin */
  margin-left: calc(
    1px + ${schoolNameWidth}px + ${spacingHelper('medium')} + ${spacingHelper('medium')}
  );
  /* border + margin + accordion + margin - right margin hack */
  margin-right: calc(
    1px + ${spacingHelper('medium')} + ${spacingHelper('medium')} + ${spacingHelper('medium')} -
      ${rowDisplacementValue}
  );
  margin-top: ${spacingHelper('medium')};
  margin-bottom: ${spacingHelper('extraSmall')};
  /* stylelint-enable declaration-block-no-redundant-longhand-properties */
`;

const SchoolFactHeader = styled(Text)`
  ${typographyHelper('overline')};
  color: ${paletteHelper('textSecondary')};
  width: 25%;
`;

export const SchoolsAccordionTable: FunctionComponent<SchoolsAccordionTableProps> = ({
  schools,
  schoolFactHeader,
}) => {
  return (
    <>
      <DesktopSchoolFactHeaderWrapper>
        {schoolFactHeader.map((header) => (
          <SchoolFactHeader key={header}>{header}</SchoolFactHeader>
        ))}
      </DesktopSchoolFactHeaderWrapper>

      <Accordion>
        {schools?.map(({ schoolName, isDefaultOpen, isZoned, schoolFacts, webLinks, tracking }) => {
          return (
            <SchoolAccordionItem
              key={schoolName}
              schoolName={schoolName}
              isDefaultOpen={isDefaultOpen}
              isZoned={isZoned}
              schoolFacts={schoolFacts}
              webLinks={webLinks}
              tracking={tracking}
            />
          );
        })}
      </Accordion>
    </>
  );
};
